import type { TreeData } from '@revelio/ui';

function isUnspecifiedLabel(name: string | null | undefined): boolean {
  const normalized = (name ?? '').trim().toLowerCase();
  return normalized === 'unspecified' || normalized.endsWith(' unspecified');
}

const sortedByNodes = new WeakMap<readonly TreeData[], TreeData[]>();

const reorder = (nodes: readonly TreeData[]): TreeData[] | null => {
  let nextNodes: TreeData[] | null = null;
  nodes.forEach((node, index) => {
    if (!node.children || node.children.length === 0) return;
    const children = reorder(node.children);
    if (children === null) return;
    nextNodes ??= [...nodes];
    nextNodes[index] = { ...node, children };
  });

  const source = nextNodes ?? nodes;
  const unspecified = source.filter((node) => isUnspecifiedLabel(node.name));
  if (unspecified.length === 0 || unspecified.length === source.length) {
    return nextNodes;
  }
  return [
    ...source.filter((node) => !isUnspecifiedLabel(node.name)),
    ...unspecified,
  ];
};

export const sortUnspecifiedNodesLast = (nodes: TreeData[]): TreeData[] => {
  const cached = sortedByNodes.get(nodes);
  if (cached !== undefined) return cached;
  const sorted = reorder(nodes) ?? nodes;
  sortedByNodes.set(nodes, sorted);
  return sorted;
};
